<template>
  <div class="media-library-tabs">
    <BbBtn
      v-for="tab in tabs"
      :key="tab.index"
      type="tertiary"
      size="x-small"
      :active="tab.index === activeTab"
      :data-attr="tab.key === MEDIA_TYPE.userImages ? 'my-images-tab-opened' : undefined"
      @click="updateActiveTab(tab.index)"
    >
      {{ tab.name }}
    </BbBtn>
  </div>
</template>

};
<script>
import { MEDIA_TYPE } from '~/constants/documents';

export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const updateActiveTab = (index) => {
      emit('on-change-tab', index);
    };

    return {
      updateActiveTab,
      MEDIA_TYPE,
    };
  },
};
</script>

<style scoped lang="scss">
.media-library-tabs {
  display: flex;
  align-items: center;
  gap: $bb-spacing-3;

  .bb-btn {
    border-bottom-width: 2px !important;
    border-color: transparent;
    font-weight: 400;

    &.v-btn--active {
      font-weight: 500;
    }
  }
}
</style>
